import React from 'react';
import TextFieldProto from './text-proto.jsx';


export default function renderTextInView(id, props) {
    return <TextFieldProto renderMode="view" id={id} {...props} />;
}